import React, { FC } from 'react';

const ZapIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="7"
      height="4"
      viewBox="0 0 7 4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.791748 1.83333H2.95841V0.75L6.20842 2.375H4.04175V3.45833L0.791748 1.83333Z"
        fill="#currentColor"
      />
    </svg>
  );
};

export default ZapIcon;
